export const SUPPORT_URL = 'https://support.pass24pro.ru';
